import React from "react";
import ServiceNowSVG from "src/icons/collections/integrations/ServiceNowSVG.svg";

const ServiceNowIcon = () => (<img src={ServiceNowSVG} alt =''/>);

export default ServiceNowIcon;
